import { lightTheme, darkTheme } from '@controlrooms/design-tokens';

export type ToastType = 'info' | 'success' | 'warning' | 'error' | 'default';

export type ToastPosition = 'top-center' | 'top-right' | 'bottom-right';

export type ToastTheme = {
  // Background colors
  backgroundColor: string;
  borderColor: string;
  hoverBackgroundColor: string;

  // Text colors
  textColor: string;
  titleColor: string;

  // Icon colors
  iconColor: string;
  iconBackgroundColor: string;

  // Type-specific colors
  infoBorderColor: string;
  successBorderColor: string;
  warningBorderColor: string;
  errorBorderColor: string;
  defaultBorderColor: string;

  // Close button
  closeButtonColor: string;
  closeButtonHoverColor: string;

  // Shadow
  shadow: string;
};

export const toastTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      backgroundColor: theme.color.surface[0],
      borderColor: theme.color.surface[3],
      hoverBackgroundColor: theme.color.surface[1],
      textColor: theme.color.text.core['-primary'],
      titleColor: theme.color.text.core['-primary'],
      iconColor: theme.color.text.core['-secondary'],
      iconBackgroundColor: theme.color.surface[2],
      infoBorderColor: theme.color.focus[1],
      successBorderColor: theme.color.dataVis.qualitative['moss-2'],
      warningBorderColor: theme.color.dataVis.qualitative['yellow-2'],
      errorBorderColor: theme.color.dataVis.alert['limit-1'],
      defaultBorderColor: theme.color.surface[3],
      closeButtonColor: theme.color.text.core['-secondary'],
      closeButtonHoverColor: theme.color.text.core['-primary'],
      shadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.15)',
    },
  ]),
);

// Legacy exports for backward compatibility
export const toastLightTheme: ToastTheme = toastTheme.light as ToastTheme;
export const toastDarkTheme: ToastTheme = toastTheme.dark as ToastTheme;
